/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsProductVersionListItem,
    IdentityMelcoModelsProductVersionListItemFromJSON,
    IdentityMelcoModelsProductVersionListItemFromJSONTyped,
    IdentityMelcoModelsProductVersionListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem {
    /**
     * 
     * @type {Array<IdentityMelcoModelsProductVersionListItem>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem
     */
    list: Array<IdentityMelcoModelsProductVersionListItem>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItemFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem {
    return IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsProductVersionListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItemToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsProductVersionListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsProductVersionListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


